import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { openConversation } from "@/lib/chat";
import { useAuth } from "@/context/AuthContext";

export const MessageSellerButton = ({ listingId, convId, className = "" }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const go = async () => {
    if (!user) return navigate("/login");
    if (convId) return navigate(`/messages/${convId}`);
    setBusy(true);
    try {
      const c = await openConversation(listingId);
      navigate(`/messages/${c.id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't open the chat. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid="message-seller-button" onClick={go} disabled={busy} className={`flex items-center justify-center gap-2 text-xs tracking-[0.3em] uppercase transition-colors disabled:opacity-50 ${className}`}>
      <MessageCircle className="h-4 w-4" strokeWidth={1.5} /> {busy ? "Opening…" : "Message seller"}
    </button>
  );
};
